module.exports = __webpack_public_path__ + "img/paci_en_2.64679316.png";